module.exports = __webpack_public_path__ + "img/i_empty_n.86ff12b3.svg";